export default __webpack_public_path__ + "static/media/slide8.e8e40f42.jpg";